import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import VueAudio from 'vue-audio';
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
import flexible from '../../../utils/flexible.js';
import { toSec } from '../../../utils/dateFormat';
import { Slider } from 'vant';
import 'vant/es/slider/style';
import guideBottom from '@/components/guideBottom.vue';
import { isWx } from '@/utils/utils';
import guideTheme from '@/components/guideTheme.vue';
import hysbwg from '@/components/hysbwg.vue';
import { setImgsize, loadScript } from '@/utils/utils';
var audio;
export default {
  name: 'audioDetailv2',
  data() {
    return {
      isPlaying: false,
      //播放按钮开关
      currentIndex: 0,
      imgList: [],
      nowTime: "00:00",
      totalTime: "",
      isFolded: false,
      antiqueDetail: {},
      location: '',
      formData: {},
      isFolded: true,
      audioPath: '',
      audio: {},
      maxValue: 1,
      //进度条长度（s）
      ctTime: 0,
      //当前进度条的值(s)
      recommendList: [],
      recommendIndex: [],
      touchNum: 0,
      hasPalyed: false,
      isLiked: false,
      //是否点击喜欢
      languageType: 0,
      hasChangeLanguage: false,
      // 列表播放按钮开关
      islistPlaying: false,
      // 列表播放路径
      listaudioPath: '',
      descflag: false,
      timer: null,
      descTimer: null,
      hasGetNewData: false,
      //普陀是否尝试了新的单位数据
      imgContainFids: ['342576'],
      audiosList: []
    };
  },
  components: {
    'vue-audio': VueAudio,
    guideBottom,
    guideTheme,
    hysbwg
  },
  methods: {
    // 修改语音类型
    changeLanguage(type) {
      this.touchNum = 2;
      this.hasChangeLanguage = true;
      this.languageType = type;
      // this.stopAudio()
      // this.$refs.audioItem.currentTime = 0
      this.$nextTick(() => {
        this.setAudioPath(this.antiqueDetail[`audioPath_${this.languageType}`], 'refresh');
      });
      if (type == 3) {
        this.language = 'en';
      } else {
        this.language = '';
      }
      let query = Object.assign({}, this.$route.query);
      if (this.language) {
        query.language = this.language;
        sessionStorage.setItem("language", this.language);
      } else {
        delete query.language;
        sessionStorage.removeItem("language");
      }
      this.$router.replace({
        path: this.$route.path,
        query
      });
      this.antiqueDetail.description = this.language ? this.antiqueDetail.en_introduction : this.antiqueDetail.introduction;
      MultiEditor.renderRichtext('editor1', this.antiqueDetail.description);
      this.audiosList = [];
      this.getNavAudioList();
    },
    // 音频快进/回退
    changePlayTime(type) {
      this.stopAudio();
      let newTime = this.$refs.audioItem.currentTime + type * 10;
      this.$refs.audioItem.currentTime = newTime;
      this.nowTime = this.formatSeconds(newTime);
      setTimeout(() => {
        this.playAudio();
      }, 200);
    },
    handleAudioTimeUpdate(e) {
      this.ctTime = e.target.currentTime;
      this.nowTime = this.formatSeconds(e.target.currentTime);
    },
    openUrl() {
      location.href = this.antiqueDetail.zhishituozhan;
    },
    // 开始拖动
    startMove: function () {
      this.stopAudio();
    },
    toDetail(item) {
      let query = Object.assign({}, this.$route.query);
      delete query.location;
      if (this.language) {
        query.language = this.language;
      } else {
        delete query.language;
      }
      this.$router.push({
        path: `/audioDetailv2/${item.code}`,
        query
      });
    },
    touchstart() {
      if (this.touchNum > 2) return;
      this.touchNum += 1;
      if (this.touchNum > 1) return;
      if (this.audioPath === '') return;
      this.playAudio();
    },
    changeTime() {
      this.nowTime = this.formatSeconds(this.ctTime);
      this.$refs.audioItem.currentTime = this.ctTime;
      this.playAudio();
    },
    toggleFold() {
      this.isFolded = !this.isFolded;
    },
    clickPlay() {
      this.stoplistAudio();
      if ((!this.touchNum || this.touchNum == 1) && window.innerWidth <= 768) return;
      this.isPlaying ? this.stopAudio() : this.playAudio();
    },
    stopAudio() {
      this.$refs.audioItem.pause();
      this.isPlaying = false;
    },
    playAudio() {
      this.isPlaying = true;
      if (!this.$refs.audioItem.paused) return;
      this.$refs.audioItem.play();
      if (!this.hasPalyed) {
        setTimeout(() => {
          this.ctTime = 0;
          this.hasPalyed = true;
        }, 500);
      }
    },
    listclickPlay(index, item) {
      this.stopAudio();
      if (this.currentIndex != index) this.listaudioPath = '';
      this.islistPlaying && this.currentIndex === index ? this.stoplistAudio(index) : this.playlistAudio(index);
    },
    stoplistAudio(index) {
      if (!this.$refs.listaudioItem) return;
      this.$refs.listaudioItem.pause();
      this.currentIndex = index ? index : 0;
      this.islistPlaying = false;
    },
    playlistAudio(index) {
      this.setlistAudioPath(this.recommendList[index].audioPath, index);
    },
    setlistAudioPath(audioPath, index) {
      if (!audioPath) return;
      this.$api.getUrlByObjectId(audioPath).then(res => {
        this.listaudioPath = res.http;
        this.$nextTick(() => {
          this.$refs.listaudioItem.play();
        });
        this.currentIndex = index;
        this.islistPlaying = true;
      });
    },
    getDetail(id) {
      this.audioPath = '';
      let searchStr = {
        filters: [[{
          alias: 'autoCode',
          compt: "editinput",
          express: '===',
          id: 28,
          range: null,
          val: this.id
        }]],
        model: 0
      };
      let formData = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(searchStr))
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        // 普陀
        if (!res.dataList.length && !this.hasGetNewData && this.$route.query.fid == 247145) {
          this.hasGetNewData = true;
          this.formData = {
            audio_formId: 2544640,
            fid: this.$route.query.fid
          };
          return this.getDetail(this.id);
        }
        this.setDatas(res.dataList[0]);
        this.getRecommend();
        let intro = this.language ? this.antiqueDetail.en_introduction : this.antiqueDetail.introduction;
        /* MultiEditor存在 */
        this.timer = setInterval(() => {
          if (MultiEditor !== undefined) {
            clearInterval(this.timer);
            MultiEditor.init('detail');
            MultiEditor.renderRichtext('editor1', intro);
          }
        }, 500);
        if (intro === '') return;
        /* introduction有值 */
        this.descTimer = setInterval(() => {
          if (document.querySelector('#desc').innerText !== '') {
            clearInterval(this.descTimer);
            let desclen = document.querySelector('#desc').innerText.length;
            if (desclen > 100) this.descflag = true;
          }
        }, 500);
      });
    },
    setDatas(data) {
      this.antiqueDetail = {
        antiqueName: !this.language ? this.getFormData(data, 'explainObj', 'val') : this.getFormData(data, 'en_explainObj', 'val'),
        description: !this.language ? this.getFormData(data, 'introduction', 'val') : this.getFormData(data, 'en_introduction', 'val'),
        audioPath: !this.language ? this.getFormData(data, 'audio', 'objectId') : this.getFormData(data, 'en_audio', 'objectId'),
        viewNum: this.getFormData(data, 'yuduliang', 'val'),
        //访问量
        likeNum: this.getFormData(data, 'dianzanliang', 'val'),
        id: data.id,
        formId: data.formId,
        zhishituozhan: this.getFormData(data, 'zhishituozhan', 'val'),
        fangyanleixing: this.getFormData(data, 'fangyanleixing', 'val'),
        en_explainObj: this.getFormData(data, 'en_explainObj', 'val'),
        explainObj: this.getFormData(data, 'explainObj', 'val'),
        en_introduction: this.getFormData(data, 'en_introduction', 'val'),
        introduction: this.getFormData(data, 'introduction', 'val'),
        // 三种音频文件
        audioPath_3: this.getFormData(data, 'en_audio', 'objectId'),
        audioPath_1: this.getFormData(data, 'audio', 'objectId'),
        audioPath_2: this.getFormData(data, 'fangyanyinpin', 'objectId'),
        41: this.getFormData(data, '41', 'val'),
        42: this.getFormData(data, '42', 'val'),
        exhibitionName: this.getFormData(data, 'exhibitionName', 'val')
        // duration: this.getFormData(data, 'time', 'val'),
      };
      this.editFormData(1); //访问量+1
      // 处理展览地点字段需根据后台实际信息实时更新
      this.location = this.language ? this.antiqueDetail['42'] === '' ? this.$route.query.location : this.antiqueDetail['42'] : this.antiqueDetail['41'] === '' ? this.$route.query.location : this.antiqueDetail['41'];
      document.title = this.antiqueDetail.antiqueName;
      this.imgList = this.getFormData(data, 'image', 'imgs');
      if (this.imgList.length > 1) {
        this.$nextTick(() => {
          new Swiper(this.$refs.swiperNav, {
            slidesPerView: 'auto',
            centeredSlides: true,
            touchMoveStopPropagation: true,
            runCallbacksOnInit: false,
            observer: true,
            //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true,
            autoplay: {
              delay: 5000,
              disableOnInteraction: false
            },
            loop: true,
            pagination: {
              el: '.audioDetail .exhibition-img .swiper-pagination'
            }
          });
        });
      }
      this.setAudioPath(this.antiqueDetail.audioPath);
      // console.log(this.antiqueDetail.audioPath, 222)
      let share = {
        title: this.antiqueDetail.antiqueName,
        imgUrl: this.imgList[0]
      };
      //   console.log(share)
      isWx().then(type => {
        if (type !== 'mini-wx') this.wechatShare(share);
      });
      //   this.wechatShare(share)
      // let maxValue = toSec(this.antiqueDetail.duration)
      // 设置duration时长为number
      // this.maxValue = maxValue
    },
    wechatShare(share) {
      return;
      let url_link = encodeURIComponent(window.location.href);
      // return
      let apiurl = '';
      if (location.protocol == 'http:') {
        apiurl = 'http://culture.chaoxing.com/api/weixin/index_new';
      } else if (location.protocol == 'https:') {
        apiurl = 'https://culture.chaoxing.com/api/weixin/index_new';
      }
      var promise = new Promise((resolve, reject) => {
        this.$ajax({
          url: apiurl + "?url=" + url_link,
          methods: 'get'
        }).then(res => {
          // console.log(res)
          resolve(res);
          // this.config = res
        }).catch(err => {
          console.log(err, 'wxerr');
          reject(err);
        });
      });
      promise.then(data => {
        wx.config({
          debug: false,
          // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: data.data.appId,
          // 必填，公众号的唯一标识
          timestamp: data.data.timestamp,
          // 必填，生成签名的时间戳
          nonceStr: data.data.nonceStr,
          // 必填，生成签名的随机串
          signature: data.data.signature,
          // 必填，签名，见附录1
          jsApiList: ['updateAppMessageShareData'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
        });
        var shareConfig = {
          share: {
            imgUrl: share.imgUrl,
            // 分享图标
            desc: '',
            // 分享描述
            title: document.title,
            // 分享标题
            link: url_link,
            // 分享出去后的链接，这里可以将链接设置成另外一个页面，必须在同一域名下面
            success: function () {
              // 分享成功之后的回调
            },
            cancel: function () {
              // 用户取消分享后执行
            },
            fail: function (res) {
              alert(JSON.stringify(res) + 'fail1');
            }
          }
        };
        // alert(JSON.stringify(shareConfig),'share')
        wx.ready(function () {
          wx.updateAppMessageShareData(shareConfig.share);
          wx.error(function (res) {
            // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
            alert(JSON.stringify(res) + 'fail2');
          });
          wx.checkJsApi({
            jsApiList: ['updateAppMessageShareData'],
            // 需要检测的JS接口列表，所有JS接口列表见附录2,
            success: function (res) {
              console.log(JSON.stringify(res));
            }
          });
        });
      });
    },
    formatSeconds(value) {
      let secondTime = parseInt(value); // 秒
      let minuteTime = 0; // 分
      let hourTime = 0; // 小时
      if (secondTime > 60) {
        minuteTime = parseInt(secondTime / 60);
        secondTime = parseInt(secondTime % 60);
        if (minuteTime > 60) {
          hourTime = parseInt(minuteTime / 60);
          minuteTime = parseInt(minuteTime % 60);
        }
      }
      let result = "" + this.addZero(parseInt(secondTime)) + "";
      if (minuteTime > 0) {
        result = "" + this.addZero(parseInt(minuteTime)) + ":" + result;
      } else {
        result = "" + this.addZero(parseInt(minuteTime)) + ":" + result;
      }
      if (hourTime > 0) {
        result = "" + parseInt(hourTime) + ":" + result;
      }
      return result;
    },
    // 左侧补零
    addZero(val) {
      if (val < 10) {
        return 0 + '' + val;
      } else {
        return val;
      }
    },
    setAudioPath(audioPath, type) {
      if (type == 'refresh') this.audioPath = '';
      if (!audioPath) return;
      this.$api.getUrlByObjectId(audioPath).then(res => {
        this.audioPath = res.http;
        if (type == 'refresh') {
          this.$nextTick(() => {
            this.playAudio();
          });
        }
        // this.audioPath = 'http://192.168.10.124:8080/test/test.mp3'
      });
    },
    getFormData(data, Tkey, key) {
      data = data.formIdValueData;
      if (!data[Tkey]) return '';
      let target = data[Tkey].groupValues[0];
      if (!target) return '';
      if (key == 'imgs') {
        let imgs = target.values.length && target.values[0] ? target.values[0] : [];
        return imgs.map(item => {
          // return item.fileUrl
          return setImgsize(item, '', '');
        });
      }
      return target.values.length && target.values[0] ? target.values[0][0] ? target.values[0][0][key] : '' : '';
    },
    getRecommend() {
      this.recommendIndex = [];
      let formData = {
        page: 1,
        limit: 50,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        orderBy: 'manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        let recommendList = this.setListDatas(res.dataList);
        recommendList.length > 1 ? this.rand(0, recommendList.length - 1) : '';
        recommendList.length > 2 ? this.rand(0, recommendList.length - 1) : '';
        this.recommendList = recommendList.filter((item, index) => {
          return this.recommendIndex.indexOf(index) > -1;
        });
        // 富文本内容 只匹配标签内的内容
        this.recommendList = this.recommendList.map(item => {
          let str = this.language ? item.en_introduction : item.introduction;
          let regx = new RegExp("<.+?>", "g");
          str = str.replaceAll(regx, '');
          item.intro = str;
          return item;
        });
        console.log(this.recommendList);
        new Swiper(this.$refs.recommonedSwiper, {
          slidesPerView: 1.7,
          spaceBetween: 15,
          touchMoveStopPropagation: true,
          runCallbacksOnInit: false,
          observer: true,
          //修改swiper自己或子元素时，自动初始化swiper
          observeParents: true
        });
      });
      this.getNavAudioList();
    },
    getNavSearchStr() {
      let filters = this.$route.query.searchKey ? [[{
        alias: 'explainObj',
        compt: "editinput",
        express: 'like',
        range: null,
        val: this.$route.query.searchKey
      }]] : [[{
        alias: 'exhibitionName',
        compt: "editinput",
        express: '===',
        id: 1,
        range: null,
        val: this.antiqueDetail.exhibitionName
      }]];
      return {
        filters,
        model: 0
      };
    },
    getNavAudioList(page = 1, list = []) {
      let formData = {
        page,
        limit: 100,
        deptId: this.formData.fid,
        formId: this.formData.audio_formId,
        searchStr: encodeURI(JSON.stringify(this.getNavSearchStr())),
        orderBy: 'manualOrderTop,manualOrder',
        orderType: 'desc'
      };
      this.$api.singleadvanceSearch(formData).then(res => {
        let audiosList = list.concat(this.setListDatas(res.dataList || []));
        if (page < res.totalPage) return this.getNavAudioList(page + 1, audiosList);
        this.audiosList = audiosList;
      });
    },
    replace() {
      this.getRecommend();
    },
    rand(m, n) {
      let data = Math.floor(Math.random() * (n - m)) + m;
      if (this.recommendIndex.indexOf(data) > -1) return this.rand(m, n);
      this.recommendIndex.push(data);
    },
    setListDatas(data) {
      return data.map(item => {
        return {
          exhibitionName: this.getFormData(item, 'exhibitionName', 'val'),
          antiqueName: this.language ? this.getFormData(item, 'en_explainObj', 'val') : this.getFormData(item, 'explainObj', 'val'),
          littleImage: this.getFormData(item, 'image', 'fileUrl'),
          code: this.getFormData(item, 'autoCode', 'val'),
          audioPath: this.getFormData(item, 'audio', 'objectId'),
          description: this.language ? this.getFormData(item, 'en_introduction', 'val') : this.getFormData(item, 'introduction', 'val'),
          en_explainObj: this.getFormData(item, 'en_explainObj', 'val'),
          explainObj: this.getFormData(item, 'explainObj', 'val'),
          en_introduction: this.getFormData(item, 'en_introduction', 'val'),
          introduction: this.getFormData(item, 'introduction', 'val')
        };
      });
    },
    getDuration(audioItem, index) {
      let audio = audioItem == 'audioItem' ? this.$refs[audioItem] : this.$refs[audioItem][0];
      if (audio && audio.readyState > 0) {
        let minutes = parseInt(audio.duration / 60, 10);
        let seconds = parseInt(audio.duration % 60);
        minutes = minutes > 9 ? minutes : `0${minutes}`;
        seconds = seconds > 9 ? seconds : `0${seconds}`;
        audioItem == 'audioItem' ? this.totalTime = minutes + ":" + seconds : this.recommendList[index].duration = minutes + ":" + seconds;
        let maxValue = toSec(this.totalTime);
        this.maxValue = maxValue;
      }
    },
    getAddress(item) {
      // console.log(item)
      let address = item['41'] && item['41'] !== '' ? item['41'] + '-' + item.exhibitionName : item.exhibitionName;
      let en_address = item['42'] && item['42'] !== '' ? item['42'] + '-' + item.en_name : item.en_name;
      return !this.language ? address : en_address;
    },
    // 编辑表单数据
    editFormData(type) {
      // type 1访问量 2 点赞量
      let putParams = [{
        "compt": "numberinput",
        "values": [{
          "val": this.antiqueDetail.viewNum ? parseInt(this.antiqueDetail.viewNum) + (type == 1 ? 1 : 0) : 0
        }],
        "alias": 'yuduliang'
      }, {
        "compt": "numberinput",
        "values": [{
          "val": this.antiqueDetail.viewNum ? parseInt(this.antiqueDetail.likeNum) + (type != 1 ? 1 : 0) : 0
        }],
        "alias": 'dianzanliang'
      }];
      putParams = encodeURI(JSON.stringify(putParams));
      this.$api.editForm(this.$route.query.fid, this.antiqueDetail.id, putParams, this.antiqueDetail.formId).then(res => {
        type == 2 ? this.isLiked = true : '';
        type == 2 ? this.antiqueDetail.likeNum = parseInt(this.antiqueDetail.likeNum) + 1 : '';
      });
    },
    setMyRecord() {
      let guideRecord = window.localStorage.getItem('guideRecord') ? JSON.parse(window.localStorage.getItem('guideRecord')) : [];
      guideRecord.push(this.id);
      window.localStorage.setItem('guideRecord', JSON.stringify(guideRecord));
    },
    getImg(data, width, height) {
      return setImgsize(data, width, height);
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
    flexible();
    let query = this.$route.query;
    this.location = query.location;
    this.id = this.$route.params.id;
    this.formData = {
      audio_formId: 171925,
      fid: query.fid
    };
    if (query.fid == 247145 && query.formId == 2544640) {
      //普陀文化馆的第二个语音导览
      this.formData = {
        audio_formId: 2544640,
        fid: query.fid
      };
    }
    this.language = this.$route.query.language;
    this.getDetail(this.id);
    if (this.$route.query.fid != 152288) return;
    this.setMyRecord();
  },
  mounted() {
    window.scrollTo(0, 0);
  },
  watch: {
    // 监听路由是否变化
    '$route'(to, from) {
      if (to.params.id != from.params.id) {
        this.id = to.params.id;
        this.location = to.query.location;
        this.totalTime = '';
        this.nowTime = '00:00';
        if (this.$refs.audioItem) {
          this.$refs.audioItem.currentTime = 0;
          this.stopAudio();
        }
        this.getDetail(this.id); // 重新调用加载数据方法
      }
    }
  },
  computed: {
    navAudiosList() {
      if (!this.audiosList || !this.audiosList.length) return [];
      return this.audiosList.filter(item => {
        return this.language ? item.en_explainObj : item.explainObj;
      });
    },
    // 当前文物在 audiosList 中的索引
    currentIndexInList() {
      if (!this.navAudiosList.length) return -1;
      return this.navAudiosList.findIndex(item => {
        return String(item.code) === String(this.id);
      });
    },
    // 上一件文物（第一件时为 null）
    prevItem() {
      const idx = this.currentIndexInList;
      if (idx <= 0) return null;
      return this.navAudiosList[idx - 1];
    },
    // 下一件文物（最后一件时为 null）
    nextItem() {
      const idx = this.currentIndexInList;
      if (idx < 0 || idx >= this.navAudiosList.length - 1) return null;
      return this.navAudiosList[idx + 1];
    }
  }
};